import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Customer } from './customer';
import { CustomerService } from './customer.service';

import {Message,ConfirmationService} from 'primeng/primeng';

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.css'],
  providers: [ConfirmationService]
})
export class CustomerComponent implements OnInit {

  customerList: Customer[];
  msgs : Message[];
  selectedCustomer : Customer;

  constructor(private customerService: CustomerService, private router: Router,
      private confirmationService: ConfirmationService) {
    this.customerList = [];
    this.msgs = [];
  }

  ngOnInit() {
    this.loadCustomers();
  }

  private loadCustomers() {
    this.customerService.list().subscribe(
      (customerArray: Customer[]) => {
        this.customerList = [];
        for (var customer of customerArray)
          this.customerList = [...this.customerList, customer];
      },
      (err) => {
        console.log(err);
        this.msgs = [];
        this.msgs.push({ severity: 'warn', summary: 'Error', detail: 'Could not load list of customers.' });
      }
    );
  }

  public addNew() {
    console.log('Navigate to new Customer component.');
    this.router.navigateByUrl('/customer/new');
  }

  /**
   * Navigate to details component
   */
  public editSelected() {
    if (this.selectedCustomer == null) {
      this.msgs = [];
      this.msgs.push({ severity: 'info', summary: 'Keine Lieferant ausgewaehlt.' });
      return;
    }

    this.router.navigate(['/customer', this.selectedCustomer.id])
  }

  public deleteSelected() {
    this.msgs = [];
    if (this.selectedCustomer == null) {
      this.msgs.push({ severity: 'info', summary: 'Keine Lieferant ausgewaehlt.' });
      return;
    }
    this.confirmationService.confirm({
      message: 'Moechten Sie den Lieferant wirlich loeschen?',
      accept: () => {
        this.customerService.delete(this.selectedCustomer.id).subscribe(
          (success: any) => {
            if (success != null && success.success) {
              this.msgs.push({ severity: 'info', summary: 'Lieferant wurde geloescht.' });
              this.loadCustomers();
            } else {
              this.msgs.push({ severity: 'warn', summary: 'Lieferant konnte nicht geloescht werden.' });
              console.log('Error on serverside.');
            }
          },
          (err) => {
            this.msgs.push({ severity: 'warn', summary: 'Lieferant konnte nicht geloescht werden.' });
            console.log(err);
          }
        );
      }
    });

  }
}


// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/customer/customer.component.ts